import Subscriptions from './Subscriptions';
import Orders from './Orders';
import Username from '../Username';

const SubscriptionsAndPurchases = () => {
	return (
		<div className="subscription-purchases">
			<div className="account-component subs-components">
				<Username />

				<Subscriptions />

				<Orders />
			</div>
		</div>
	);
};

export default SubscriptionsAndPurchases;
